import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { PERIODS_OPERATION_TYPES, summarizeSubtractPeriodValues } from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetFinancialActivitiesNetCashCalculation = () => {
  const { setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [financialActivitiesNetCashFiled] = observedFields.financialActivitiesNetCash.setCalculatedValueFieldNames;

  const getFinancialActivitiesNetCashCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;
        const [proceedsIssuanceDebt, proceedsIssuanceEquity, repaymentDebt, financialActivitiesTableValues] = content;
        const financialActivitiesNetCash = summarizeSubtractPeriodValues(
          [proceedsIssuanceDebt, proceedsIssuanceEquity, repaymentDebt, ...financialActivitiesTableValues],
          PERIODS_OPERATION_TYPES.ADD,
        );

        setValue(financialActivitiesNetCashFiled, financialActivitiesNetCash);
      }, 500),

    [],
  );

  return getFinancialActivitiesNetCashCalculationHandler;
};
